import {Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {CommonService} from 'src/app/core/services/common.service';
import {Message} from '../../../core/class/message';
import {BehaviorSubject, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {BreadcrumbsService} from '../../../shared/components/breadcrumbs/breadcrumbs.service';
import {SignPositionTypes} from '../../../core/constants/signposition-types';
import {SignDocumentComponent} from '../../dashboard/home/home-enterprise/document/sign-document/sign-document.component';
import {TranslateService} from '@ngx-translate/core';
import {SCREEN_SIZE} from '../../../core/constants/screen-size';
import {CanvasComponent} from '../../../shared/components/canvas/canvas.component';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import { format } from 'date-fns';
import {Common} from '../../../core/constants/common';
import {MatDialog} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';
import {DigitalCertificateService} from '../../../core/services/digital-certificate.service';
import {DomSanitizer} from '@angular/platform-browser';
import {SignDocumentService} from '../../../core/services/sign-document.service';
import {DocumentService} from '../../../core/services/document.service';
import {CanvasService} from '../../../core/services/canvas.service';
import {AnonymousSignService} from '../../../core/services/anonymous-sign.service';
import {NotificationService} from '../../../core/services/notification.service';
import {ResponsiveService} from '../../../core/services/responsive.service';
import {first} from 'rxjs/operators';
import {UploadFile} from 'ng-zorro-antd/upload';
import {KycService} from '../../../core/services/kyc.service';
import {ConfirmSuccessComponent} from '../confirm-success/confirm-success.component';
import {ConfirmFailComponent} from '../confirm-fail/confirm-fail.component';
import {ErrorCode} from "../../../core/constants/error-code";
import { CloudCaProvider } from '../../dashboard/home/home-enterprise/digital-certificate/add-digital-certificate/add-digital-certificate.component';
import { debug } from 'util';
import { ConfirmCancelComponent } from '../confirm-cancel/confirm-cancel.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

declare var $: any;

declare function initPluginCertificate(comp: any): any;

declare function anonymousSignHashAsyncNew(comp, hashBase64, sessionId, serialNumber): any;

@Component({
  selector: 'app-kyc-confirm-account',
  templateUrl: './kyc-sign.component.html',
  styleUrls: ['./kyc-sign.component.scss']
})
export class KycSignComponent implements OnInit, OnDestroy, AfterViewInit {
  public language: string;
  public isClickSignBuuton = false;
  public isShowSidebarButton = true;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public isAllowSelectSignPosition = true;
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  errorFormatTypeFile = false;
  maxSizeInput = false;
  usbTokenCertificate = {
    certRawdata: '',
    taxCode: '',
    serialNumber: '',
    issuedTo: '',
    issuedBy: '',
    expireDate: new Date(),
    activeDate: new Date(),
    fileName: '',
    certificateName: '',
    distinguishedName: ''
  };
  @ViewChild('inputUpload', {read: '', static: false}) inputUploadFile: ElementRef;
  private imagePreviewWidth: number;
  private imagePreviewHeight: number;

  private hashKey: string;
  private tenantId: string;
  private contractIdAndContractEnterpriseIdEncode: string = null;
  listOfDataSimCa: SimCaDataItem[] = [];

  private leftPosition: number;
  page: number;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  status: '';
  serviceType: '';
  serviceTypeEntity: any;
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  goFrom: string;
  public document: any;
  selectedImage: File;
  selectedImageUrl: string | ArrayBuffer;
  isDisableNextButton = true;
  private indexSelect: number;
  public signPosition: any[];
  private isSelectedCertSource = new BehaviorSubject(false);
  isSelectedCert = this.isSelectedCertSource.asObservable();

  private isGotoSignpage = false;
  private sign: any;
  private certificate = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined
  };
  private success: boolean;
  public enterpriseName: string;
  public tempEnterprise:any
  private imageData = [];

  public imageUrlPreview: any;

  private pageIndex = 0;
  private isSelectPosition: any;
  private stampWrapper: HTMLDivElement;
  widthRectangle = 300;
  heightRectangle = 136;
  private signPage: any;

  private isSelectDrawImage = false;
  public fileUpload: File;
  public loading: boolean;
  public avatarUrl: string;

  current = 0;

  index = 'First-content';
  typeCertificate: number;
  public selectedCert = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: '',
    taxCode: '',
    certificateName: '',
    cloudCaUserId: ''
  };
  public disableBtnDeleteCanvas: boolean;
  public signMethod = {
    SIGN_SERVER: 0,
    SIGN_USB_TOKEN: 1,
    SIGN_SIM_CA: 2,
    SIGN_OTP: 3,
    SIGN_CLOUD_CA: 4,
    // SIGN_HSM: 4,
    // SIGN_IMAGE: 5,
    SIGN_NO_CERT: 6
  };
  private userType: number;
  private enterpriseId: string;
  @Input() public canvasWidth = 660;
  @Input() public canvasHeight = 300;
  pdfSrc: string;
  zoomLevel = 100;
  currentDate = new Date();
  @ViewChild('myCanvas', {static: false}) canvas: ElementRef;
  @ViewChild('navigation', {static: false}) navigation: ElementRef;

  // @ts-ignore
  @ViewChild(CanvasComponent) canvasComponent;

  @BlockUI() blockUI: NgBlockUI;

  thumbnail = [];

  beforeUpload = this.commonService.beforeUploadImage;
  isVisible = false;
  dateNow = format(new Date(), 'DD/MM/YYYY');
  typeSelectCertificate: number;
  simCaPhoneNumber = '';
  private selectedCertSimCa: any;
  valueSelectUploadUsb = 1;
  checkFocus: boolean;
  errorStatus: string;
  errorInitPlugin: boolean;
  pageCurrent = 1;
  sessionId: string;
  certData: string;

  signDataValidate;
  otpPhoneNumber = '';
  otpPhoneNumberMaxLength = Common.PHONE_MAXLENGTH;
  otpPhoneNumberPattern = Common.PHONE_PATTERN;
  private dialogRef: any;
  listEnterprise;
  signPositionTypes = SignPositionTypes;
  onlyDigital = false;

  /**
   * CloudCA variables
   */
  lstCloudCaProvider: CloudCaProvider[];
  providerName = '';
  providerId : number;
  cloudCaUsername: string;
  cloudCaDataSource: CloudCaDataItem[] = [];
  private processingId: string = null;
  signProcessing: any[] = [];
  public isCancelSign = false;
  signError: string = null;
  isCancel: boolean = false;
  isCallDone: boolean = false;
  typeVerify: string = '';
  subscription: Subscription;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private dialog: MatDialog,
              public commonService: CommonService,
              public message: Message,
              private toastr: ToastrService,
              private digitalCertificateService: DigitalCertificateService,
              private sanitizer: DomSanitizer,
              private translateService: TranslateService,
              private activeRoute: ActivatedRoute,
              private signDocumentService: SignDocumentService,
              private breadcrumbsService: BreadcrumbsService,
              private documentService: DocumentService,
              private canvasService: CanvasService,
              private anonymousSignService: AnonymousSignService,
              private notificationService: NotificationService,
              private responsiveService: ResponsiveService,
              private kycService: KycService) {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.isShowSidebarButton = false;
      this.zoomLevel = 50;
    }
    this.userType = Number(localStorage.getItem('userType'));
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.enterpriseName = 'enterprise name demo';
    this.tempEnterprise = JSON.parse(localStorage.getItem('tempEnterprise'));
    this.language = localStorage.getItem('__language') || 'vi';
    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        this.typeVerify = params.type;
      });
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
    });
  }

  ngOnInit() {
    this.signDataValidate = JSON.parse(localStorage.getItem('SignDataValidateKyc'));
    this.viewDocumentUpload();
    this.notificationService.subscribeErrorService();
    this.subscribeValue();

    this.commonService.getCurrentLanguage().subscribe(lang => {
      if (lang !== this.language) {
        location.reload();
      }
    });

    /**
     * get provider cloud ca
     */
    this.commonService.getAllCloudCaProvider().subscribe(rs => {
      if (rs && rs.data) {
        this.lstCloudCaProvider = rs.data;
        this.providerName = this.lstCloudCaProvider[0].name;
        this.providerId = this.lstCloudCaProvider[0].id;

      }
    })

  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          switch (this.mediaBreakpoint) {
            case SCREEN_SIZE.XS:
              this.canvasWidth = 340;
              break;
            case SCREEN_SIZE.SM:
              this.canvasWidth = 345;
              break;
            case SCREEN_SIZE.MD:
              this.canvasWidth = 450;
              break;
            default:
              this.canvasWidth = 660;
              break;
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await this.commonService.getBase64(file.originFileObj!);
    }
  };

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  pre(): void {
    this.current -= 1;
    if (this.current < 2) {
      const nodeOther = document.getElementById('show-frames-notification');
      if (nodeOther) {
        nodeOther.remove();
      }
    }

    if (this.current === 1) {
      this.avatarUrl = null;
      this.isSelectDrawImage = false;
      this.fileUpload = this.selectedImage;
      this.imageUrlPreview = this.selectedImageUrl;
      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
        this.isDisableNextButton = true;
      }
    }

    if (this.current === 0) {
      this.isSelectDrawImage = false;
      this.fileUpload = null;
      this.imageUrlPreview = '';
      this.avatarUrl = null;
      if (this.selectedCert) {
        this.isDisableNextButton = false;
      }
    }
  }

  decodeTaxCode(taxCode: string): string {
    const arrs = taxCode.split(',');
    for (let element of arrs) {
      if (element.trim().startsWith('MST') || element.trim().startsWith('CMND') || element.trim().startsWith('CCCD')) {
        return element.split(':')[1];
      }
    }
    return '';
  }

  next() {
    // check simCA hoặc Usb token
    if (this.typeCertificate === this.signMethod.SIGN_SIM_CA
      || this.typeCertificate === this.signMethod.SIGN_USB_TOKEN
      || this.typeCertificate === this.signMethod.SIGN_CLOUD_CA) {
        var selectedCACertficateNo = '';
        var selectedCAName = '';
      if (this.typeCertificate === this.signMethod.SIGN_SIM_CA || this.typeCertificate === this.signMethod.SIGN_CLOUD_CA) {
        selectedCACertficateNo = this.selectedCert.taxCode;
        selectedCAName = this.selectedCert.certificateName;
      } else {
        const taxCode = this.usbTokenCertificate.taxCode;
        selectedCACertficateNo = this.decodeTaxCode(taxCode);
        selectedCAName = this.usbTokenCertificate.issuedTo;
      }
      if (this.signDataValidate != null) {
        // check mã số thuế
          if (selectedCACertficateNo.length > 0 &&
            (selectedCACertficateNo.toUpperCase() === this.signDataValidate.certificateNo.toUpperCase() ||
              (this.signDataValidate.representDocumentNumber && selectedCACertficateNo.toUpperCase() === this.signDataValidate.representDocumentNumber.toUpperCase()) ||
              (this.signDataValidate.taxCode && selectedCACertficateNo.toUpperCase() === this.signDataValidate.taxCode.toUpperCase()))) {
            // next step
          } else {
            this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
            return false;
          }

        // check name
          if (this.signDataValidate.name && (selectedCAName.toUpperCase() !== this.signDataValidate.name.toUpperCase())) {
            this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_name'));
            return false;
          }
        }
    }

    this.current += 1;
    if (this.current === 1) {
      if (this.typeSelectCertificate === 1) { // ký bằng usb token
        this.selectedCert = {
          ...this.selectedCert,
          ...this.usbTokenCertificate
        };
      }
      if (this.selectedCert !== null) {
        this.handleSelectedCert();
        this.otpPhoneNumber = this.digitalCertificateService.formatPhoneNumber(this.otpPhoneNumber);
      }
    }
    // sau khi chọn ảnh, đến trang chọn vị trí
    if (this.current === 2) {
      this.isVisible = true;
      if (this.isSelectDrawImage) {
        this.canvasComponent.onSaveCanvas();
      } else {
        if (this.fileUpload) {
          this.handlePreviewFromFileUpload(this.fileUpload);
        }
      }
      // hiển thị thông báo người dùng chọn vị trí
      if (this.isAllowSelectSignPosition) {
        this.onStamped();
      }
    }
    // this.changeContent();
  }

  handlePreviewFromFileUpload(fileUpload: File) {
    this.commonService.getBase64(fileUpload)
      // tslint:disable-next-line:no-shadowed-variable
      .then((imageUrlPreviewBlod) => {
        this.imageUrlPreview = imageUrlPreviewBlod;
        this.selectedImageUrl = imageUrlPreviewBlod;
      });
  }

  handleSelectedCert() {
    if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT || this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT) {
      this.isDisableNextButton = true;
    }
    if (this.selectedCert.imageUrl) {
      // @ts-ignore
      fetch(this.selectedCert.imageUrl)
        .then(r => r.blob())
        .then(blobFile => {
          this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
          this.selectedImage = this.fileUpload;
        });

      const img = new Image();
      img.src = this.selectedCert.imageUrl;
      img.onload = () => {
        // Get  width
        this.leftPosition = (this.widthRectangle - img.width * this.heightRectangle / img.height) / 2;
        // tslint:disable-next-line:max-line-length
        // contentNode = `<img src="${this.selectedCert.imageUrl}" style="height: 100%; position: relative; left: ${leftPosition}px;"/>`;
      };
    }
  }

  done(): void {
  }

  onSelectDrawSign() {
    // this.disableBtnDeleteCanvas = true;
    // this.commonService.configCanvas(this.canvas.nativeElement, this.cx, this.canvasWidth, this.canvasHeight);
    this.canvasService.setIsSelectSignDraw(true);
  }

  subscribeValue() {
    // this.documentService.contractInfo.subscribe(contract => {
    //   if (!contract) {
    //     this.getDocumentById(this.contractId);
    //   } else {
    //     this.document = contract;
    //   }
    // });

    this.canvasService.canvasImageUrl.subscribe(url => {
      if (this.isSelectDrawImage) {
        this.imageUrlPreview = url;
      }
    });

    this.canvasService.canvasImage.subscribe(fileImage => {
      if (this.isSelectDrawImage) {
        this.fileUpload = fileImage;
      }
    });

    this.canvasService.isDisableBtnDeleteCanvas.subscribe(disable => {
      this.disableBtnDeleteCanvas = disable;
      if (disable && this.current === 1 && this.indexSelect === 2) {
        this.isDisableNextButton = disable;
      } else if (disable && this.current === 1 && this.indexSelect === 1 && (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT || this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT)) {
        this.isDisableNextButton = true;
      } else {
        this.isDisableNextButton = false;
      }
    });

    this.isSelectedCert.subscribe(value => {
      if (this.current === 0) {
        this.isDisableNextButton = !value;
      }
    });

    // lấy sign position
    const position = JSON.parse(localStorage.getItem('SignPosition'));
    this.signPosition = position;
    if (position && position.length > 0) {
      if (this.signPosition.length === 1 && this.signPosition[0].signType === this.signPositionTypes.DIGITAL) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
      this.isAllowSelectSignPosition = false;
      this.imageData = position.map((item) => {
        return {
          positionX: item.x,
          positionY: item.y,
          pageNumber: item.pageNumber,
          signType: item.signType,
          widthRectangle: item.width,
          heightRectangle: item.height,
          zoom: 1
        };
      });
    } else {
      this.isAllowSelectSignPosition = true;
      this.signPosition = [];
    }
  }

  setIsSelectedCert(value) {
    this.isSelectedCertSource.next(value);
  }

  getDocumentById(id: string) {
    if (id) {
      this.documentService.getDocumentById(id).subscribe(rs => {
        // this.document = rs.data.contractDTO;
        this.documentService.setContractInfo(rs.data.contractDTO);
        if (rs.data.contractSignEntityList) {
          this.documentService.setSignPosition(rs.data.contractSignEntityList);
        } else {
          this.documentService.setSignPosition(null);
        }
      });
    }
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileUpload = file;
    this.isDisableNextButton = false;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  viewDocumentUpload() {
    if(this.tempEnterprise){
      try {
        this.kycService.verifyNewAccountGetPdf(this.tempEnterprise).subscribe(res => {
          this.showPdf(res);
        });
      } catch (e) {
      }
    }else{
      try {
        this.kycService.checkErrorVerifyAccountGetPdf().subscribe(res => {
          if (res.success == false) {
            this.toastr.error(res.message);
          } else {
            this.kycService.verifyAccountGetPdf().subscribe(rs => {
              this.showPdf(rs);
            })
          }
        });
      } catch (e) {
      }
    }

  }

  handleChange(info: { file: UploadFile }): void {
    // this.isFormChanging = true;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        // tslint:disable-next-line:no-non-null-assertion
        this.commonService.getBase64Avatar(info.file!.originFileObj!, (imgUrl: string) => {
          this.loading = false;
          // tslint:disable-next-line:radix
          const img = new Image();
          // Set the src attribute to your URL
          img.src = imgUrl;
          this.imagePreviewWidth = img.width;
          this.imagePreviewHeight = img.height;
          // When the image is loaded, read the available properties
          this.avatarUrl = imgUrl;
          this.imageUrlPreview = imgUrl;
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  getStampWrapper(positionX: number, positionY: number, width: number, height: number, signType: string) {
    const stampNode = document.createElement('div');
    // stampNode.innerHTML = this.genStampContent();
    const signatureWidth = width * this.zoomLevel / 100;
    const heightRectangle = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;

    // positionX: 100 * wrapperLeft / zoomLevel;
    // positionY: 100 * wrapperTop / zoomLevel;
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';
    stampNode.style.fontFamily = 'Roboto, sans-serif';
    stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
    if (this.fileUpload) {
      stampNode.style.display = 'flex';
      stampNode.style.alignItems = 'center';
      stampNode.style.justifyContent = 'center';
    }

    stampNode.innerHTML = this.genStampContentWidthHeight(width, height, signType);
    // element.appendChild(stampNode);

    return stampNode;
  }

  genStampContentWidthHeight(widthRect: number, heightRect: number, signType: string): string {
    let contentNode: string;
    if (this.fileUpload) {
      const padding = 10;
      const zoom = this.zoomLevel / 100;
      let widthRectangle = widthRect * zoom;
      let heightRectangle = heightRect * zoom;

      widthRectangle -= padding * zoom * 2;
      heightRectangle -= padding * zoom * 2;

      let height = widthRectangle;
      let width = heightRectangle;
      const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
      if (this.imagePreviewWidth > this.imagePreviewHeight) {
        width = widthRectangle;
        height = width / ratio;
        if (height > heightRectangle) {
          height = heightRectangle;
          width = height * ratio;
        }
      } else {
        height = heightRectangle;
        width = height * ratio;
      }

      const heightPx = `${height}px`;
      const widthPx = `${width}px`;

      if (signType === SignPositionTypes.DIGITAL) {
        contentNode = `<div></div>`;
      } else {
        contentNode = `<img src="${this.imageUrlPreview}"  style="height: ${heightPx};width: ${widthPx}; margin: auto; display: flex; justify-content: flex-end; align-items: flex-start;"/>`;
      }

    } else {
      if (this.typeSelectCertificate === this.signMethod.SIGN_SIM_CA && ((this.signPosition && this.signPosition.length > 0) || (this.signPosition && this.signPosition.length === 0))) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `
            <div>
                    ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.certificateName}
                    <br/>
                    ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                  </div>
            `;
        }
      } else if ((this.signPosition && this.signPosition.length > 1) || (this.signPosition && this.signPosition.length === 0)) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `<div>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.usbTokenCertificate.issuedTo}
                  <br/>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                </div>`;
        }
      } else if (this.signPosition && this.signPosition.length === 1 && this.signPosition[0].signType === SignPositionTypes.DIGITAL) {
        contentNode = `<div></div>`;
      }
    }
    return contentNode;
  }

  textLayerRendered(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber;

    // lấy các chữ ở trang pageNumber
    let signPosition;
    if (this.signPosition && this.signPosition.length > 0) {
      signPosition = this.signPosition.filter((item) => {
        return item.pageNumber === pageIndex;
      });
    }

    if (signPosition && signPosition.length > 0) {
      for (const position of signPosition) {
        const x = position.x;
        const y = position.y;
        const _width = position.width;
        const _height = position.height;
        const signType = position.signType;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, signType);
        element.appendChild(htmlNode);
      }
      if (!this.isGotoSignpage) {
        const firstPosition = signPosition[0];
        const firstPage = firstPosition.pageNumber;
        this.signPage = firstPosition.pageNumber;
        this.gotoSignPageNumber(firstPage);
        this.isGotoSignpage = true;
      }
    } else {
      element.addEventListener('mouseleave', (mouseoverEvent) => {
        if (this.isSelectPosition) {
          const nodeOther = document.getElementById('show-frames-notification');
          if (nodeOther) {
            nodeOther.remove();
          }
        }
      });
      element.addEventListener('wheel', (wheelEvent) => {
        if (this.isSelectPosition) {
          const node = element.querySelector('#show-frames-notification');
          const nodeOther = document.getElementById('show-frames-notificationn');
          if (!node && nodeOther) {
            nodeOther.remove();
          }
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          if (!node) {
            const stampNode = document.createElement('div');
            stampNode.innerHTML = this.genStampContent();
            this.stampWrapper = stampNode;
            stampNode.style.position = 'absolute';
            stampNode.setAttribute('id', 'show-frames-notification');
            stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
            stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${heightRectangle}px`;
            stampNode.style.zIndex = '1';
            stampNode.style.background = 'rgb(0,0,0,0.2)';
            stampNode.style.border = '1px solid';
            stampNode.style.lineHeight = '1.9';
            stampNode.style.color = '#00f';
            stampNode.style.fontFamily = 'Roboto, sans-serif';
            stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
            if (this.fileUpload) {
              stampNode.style.display = 'flex';
              stampNode.style.alignItems = 'center';
              stampNode.style.justifyContent = 'center';
            }

            element.appendChild(stampNode);
          } else {
            node.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
            node.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
          }
        }
      });
      element.addEventListener('mousedown', (mousedownEvent) => {
        if (this.isSelectPosition) {
          this.isSelectPosition = false;
          // xoá dòng chọn vị trí
          const framesNotification = document.getElementById('show-frames-notification');
          if (framesNotification) {
            framesNotification.remove();
          }
          const offsetParent = element.offsetParent.dataset;
          const {pageNumber} = offsetParent;
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;

          const wrapperLeft = mousedownEvent.clientX - signatureWidth / 2 - left;
          const wrapperTop = mousedownEvent.clientY - heightRectangle / 2 - top;
          this.stampWrapper.style.left = `${wrapperLeft}px`;
          this.stampWrapper.style.top = `${wrapperTop}px`;
          this.stampWrapper.style.width = `${signatureWidth}px`;
          this.stampWrapper.style.height = `${heightRectangle}px`;
          this.stampWrapper.style.background = 'rgb(0,0,0,0.2)';
          this.stampWrapper.style.zIndex = '1';
          this.stampWrapper.style.border = '1px solid #999999';
          this.stampWrapper.style.lineHeight = '1.9';
          this.stampWrapper.style.color = '#00f';
          this.stampWrapper.style.fontFamily = 'Roboto, sans-serif';
          this.stampWrapper.style.padding = `${10 * this.zoomLevel / 100}px`;
          if (this.fileUpload) {
            this.stampWrapper.style.display = 'flex';
            this.stampWrapper.style.alignItems = 'center';
            this.stampWrapper.style.justifyContent = 'center';
          }

          this.stampWrapper.innerHTML = this.genStampContent();
          element.appendChild(this.stampWrapper);

          // xoá dòng thông báo click để chọn vị trí
          document.querySelectorAll('#notify_outside').forEach(item => {
            if (item) {
              item.remove();
            }
          });
          const zoomLevel = this.zoomLevel;
          this.imageData = [{
            stampPositionLeft: mousedownEvent.clientX - signatureWidth / 2 - left,
            stampPositionTop: mousedownEvent.clientY - heightRectangle / 2 - top,
            // positionX: (mousedownEvent.clientX - signatureWidth / 2 - left) / zoomLevel,
            positionX: 100 * wrapperLeft / zoomLevel,
            // positionY: (mousedownEvent.clientY - heightRectangle / 2 - top) / zoomLevel,
            positionY: 100 * wrapperTop / zoomLevel,
            pageIndex,
            zoom: this.zoomLevel,
            pdfSrc: this.pdfSrc,
            pageNumber,
            signType: SignPositionTypes.COMBINE,
            type: SignDocumentComponent.SIGN_SINGLE,
            widthRectangle: this.widthRectangle,
            heightRectangle: this.heightRectangle
          }];
        }
      });
      element.addEventListener('mousemove', (mousemoveEvent) => {

        if (this.isSelectPosition) {
          // xoá dòng chọn vị trí
          const node = element.querySelector('#show-frames-notification');
          const nodeOther = document.getElementById('show-frames-notification');
          if (!node && nodeOther) {
            nodeOther.remove();
          }
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          if (!node) {
            const stampNode = document.createElement('div');
            stampNode.innerHTML = this.genStampContent();
            stampNode.style.position = 'absolute';
            stampNode.setAttribute('id', 'show-frames-notification');
            stampNode.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
            stampNode.style.top = `${(mousemoveEvent.clientY - heightRectangle / 2 - top)}px`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${heightRectangle}px`;
            stampNode.style.zIndex = '1';
            stampNode.style.background = 'rgb(0,0,0,0.2)';
            stampNode.style.border = '1px solid';
            stampNode.style.lineHeight = '1.9';
            stampNode.style.color = '#00f';
            stampNode.style.fontFamily = 'Roboto, sans-serif';
            stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
            if (this.fileUpload) {
              stampNode.style.display = 'flex';
              stampNode.style.alignItems = 'center';
              stampNode.style.justifyContent = 'center';
            }

            element.appendChild(stampNode);
          } else {
            node.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
            node.style.top = `${(mousemoveEvent.clientY - heightRectangle / 2 - top)}px`;
          }
        }
      });
    }
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}`);
    this.pageIndex++;
  }

  showPdf(blob: any) {
    const file = this.blobToFile(blob, 'application/pdf');
    this.commonService.readFile(file, (pdfSrc) => {
      this.pdfSrc = pdfSrc;
    });
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  gotoSignPageNumber(signPage: number) {
    this.pageCurrent = signPage;
  }

  onStamped() {
    this.isSelectPosition = true;
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    this.showFramesNotification();
  }

  showFramesNotification() {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const navBoundingClient = this.navigation.nativeElement.getBoundingClientRect();
    const {top, left, bottom, width, height} = navBoundingClient;
    const signatureWidth = this.widthRectangle * this.zoomLevel;
    const heightRectangle = this.heightRectangle * this.zoomLevel;
    const navigation = document.getElementById('navigation');
    const newTop = top - 2 * heightRectangle;
    const newLeft = width / 2 - signatureWidth / 2;
    const stampNode = document.createElement('div');
    stampNode.setAttribute('id', 'show-frames-notification');
    const contentNode = `<span style="color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</span>`;
    stampNode.style.position = 'absolute';
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.innerHTML = contentNode;
    stampNode.style.left = `${newLeft}px`;
    stampNode.style.top = `${newTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    if (this.fileUpload) {
      stampNode.style.display = 'flex';
      stampNode.style.alignItems = 'center';
      stampNode.style.justifyContent = 'center';
    }
    this.stampWrapper = stampNode;
    navigation.appendChild(stampNode);
  }

  pageRendered(e) {
    // this.thumbnail.push({
    //   page: e.pageNumber,
    //   url: e.source.canvas.toDataURL()
    // });
  }

  gotoPage(page: number) {
    const textLayer = document.getElementById(`text-pdf-layer-${page - 1}`);
    if (textLayer) {
      textLayer.scrollIntoView();
    }
  }

  processSignSimCAImage() {
    this.blockUI.start('');
    const position = JSON.parse(localStorage.getItem('SignPosition'));
    if (position) {
      const positionConvert = [];
      position.map(pos => {
        positionConvert.push({
          positionY: pos.y,
          pageNumber: pos.pageNumber,
          positionX: pos.x,
          widthRectangle: pos.width,
          heightRectangle: pos.height,
          signType: pos.signType
        });
      });
      this.sign = {
        ...this.sign,
        listSignPosition: JSON.stringify(positionConvert)
      };
    }

    if (this.fileUpload) {
      const reader = new FileReader();
      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsBinaryString(this.fileUpload);
    }

    setTimeout(() => {
      if(this.tempEnterprise){
        const payload ={
          type:this.signMethod.SIGN_SIM_CA,
          verifySignDTO:this.sign,
          enterpriseUpdateInfoDTO: this.tempEnterprise,
          verify: false,
        }
        this.kycService.verifyAndUpdate(payload).subscribe(rs => {
          if (rs.success) {
            this.onSignSuccess();
          } else {
            this.onSignFail(rs.message);
          }
        }, error => {
          console.log(error);
        });
      }else{
        this.kycService.signSimCAImage(this.sign).subscribe(rs => {
          if (rs.success) {
            this.onSignSuccess();
          } else {
            this.onSignFail(rs.message);
          }
        }, error => {
          console.log(error);
        });
      }
    }, 500);
  }

  processSignSimCANoImage() {
    this.blockUI.start('');
    if(this.tempEnterprise){
      const payload ={
        type:this.signMethod.SIGN_SIM_CA,
        verifySignDTO:this.sign,
        enterpriseUpdateInfoDTO: this.tempEnterprise,
        verify: false,
      }
      this.kycService.verifyAndUpdate(payload).subscribe(rs => {
        if (rs.success) {
          this.onSignSuccess();
        } else {
          this.onSignFail(rs.message);
        }
      }, error => {
        console.log(error);
      });
    }else{
      this.kycService.signSimCAImage(this.sign).subscribe(rs => {
        this.isClickSignBuuton=false
        if (rs.success) {
          this.onSignSuccess();
        } else {
          this.onSignFail(rs.message);
        }
      }, error => {
        this.isClickSignBuuton=false
        console.log(error);
      });
    }
  }

  async processSignCloudCA() {
    this.blockUI.start('');
    // let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;

    const data = {
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      signMethod: this.typeCertificate,
      // contractId: this.document.id,
      mainContractAttachments: mainContractAttachmentsNew,
      // certificate: this.sign.certificates,
      // digitalCertificateDetailId: this.selectedCert.idDetail,
      // phoneNumber: this.selectedCert.phoneNumber,
      serialNumber: this.selectedCert.serialNumber,
      providerName: this.providerName,
      credentialId: this.sign.credentialId,
      cloudCaUserId: this.cloudCaUsername,
      listSignPosition: this.imageData
    };

    if (!this.tempEnterprise) {
      const res = await this.kycService.signCloudCa(data).toPromise();
      this.isClickSignBuuton=false
      if (res && res.data && res.success != false) {
        this.onSignSuccess();
      } else {
        this.onSignFail(res.message);
      }
    }else{
      const payload ={
        type:this.signMethod.SIGN_CLOUD_CA,
        verifySignDTO:data,
        enterpriseUpdateInfoDTO: this.tempEnterprise,
        verify: false,
      }
      const res = await this.kycService.verifyAndUpdate(payload).toPromise();
      if (res && res.data && res.success != false) {
        this.onSignSuccess();
      } else {
        this.onSignFail(res.message);
      }
    }
  }


  onClickConfirmButtonNoImage() {
    switch (this.typeSelectCertificate) {
      case this.signMethod.SIGN_USB_TOKEN:
        //this.blockUI.start('');
        //initPluginCertificateNormal(this);
        this.createHash(this.usbTokenCertificate.certRawdata);
        break;
      case this.signMethod.SIGN_SIM_CA:
        this.processSignSimCANoImage();
        break;
      case this.signMethod.SIGN_CLOUD_CA:
        this.processSignCloudCA();
        break;
      default:
        break;
    }
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  onSelectedCloudCaCert(event: any, cert) {
    if (event === true) {
      this.selectedCert = cert;
      this.isDisableNextButton = false;
      this.cloudCaDataSource = this.cloudCaDataSource.map(item => {
        return { ...item, checked: cert.STT === item.STT };
      });
    } else {
      this.isDisableNextButton = true;
      this.selectedCertSimCa = null;
    }
  }

  onClickConfirmButtonImage() {
    switch (this.typeSelectCertificate) {
      case this.signMethod.SIGN_USB_TOKEN:
        //this.blockUI.start('');
        // initPluginCertificateNormal(this);
        this.createHash(this.usbTokenCertificate.certRawdata);
        break;
      case this.signMethod.SIGN_SIM_CA:
        this.processSignSimCAImage();
        break;
      case this.signMethod.SIGN_CLOUD_CA:
        this.processSignCloudCA();
        break;
      default:
        break;
    }
  }

  createHash(certUserBase64: string) {
    this.sign.certificate = certUserBase64;
    const position = JSON.parse(localStorage.getItem('SignPosition'));
    if(this.tempEnterprise){
      this.sign ={
        ...this.sign,
        enterpriseUpdateInfoDTO: this.tempEnterprise
      }
    }
    if (position) {
      const positionConvert = [];
      position.map(pos => {
        positionConvert.push({
          positionY: pos.y,
          pageNumber: pos.pageNumber,
          positionX: pos.x,
          widthRectangle: pos.width,
          heightRectangle: pos.height,
          signType: pos.signType
        });
      });
      this.sign = {
        ...this.sign,
        listSignPosition: positionConvert,
      };
    }

    if (this.fileUpload) {
      const reader = new FileReader();
      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsBinaryString(this.fileUpload);

      //   this.anonymousSignService.createHashWithImage(this.sign).subscribe(rs => {
      //    this.sign.path = rs.data.path;
      //   this.sign.signPdf = rs.data.signPdf;
      //  this.sign.signature = signHash(this, rs.data.hash);
      //  this.signUsb(this.sign);
      setTimeout(() => {
        this.kycService.createHashWithImage(this.sign).subscribe(rs => {
          this.isClickSignBuuton = false;
          this.sign.path = rs.data.path;
          this.sign.signPdf = rs.data.signPdf;
          // this.sign.signature = signHash(this, rs.data.hash);
          // this.sign.signature = anonymousSignHash(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
          // this.signUsb(this.sign);
          anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber).then(
            signature => {
              if (!signature) {
                this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
                return;
              }
              this.sign.signature = signature;
              return this.signUsb(this.sign);
            }
          ).catch(e => {
            if (e.errorCode) {
              if (e.errorCode === 401) {
                // ngươif dùng huỷ, không chọn cts
                return;
              }
            }
            this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
          });
        });
      }, 500);
    } else {
      this.kycService.createHashNoImage(this.sign).subscribe(rs => {
        this.isClickSignBuuton = false;
        console.log(rs)
        this.sign.path = rs.data.path;
        this.sign.signPdf = rs.data.signPdf;
        // this.sign.signature = signHash(this, rs.data.hash);
        // this.sign.signature = anonymousSignHash(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
        // this.signUsb(this.sign);
        anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber).then(
          signature => {
            if (!signature) {
              this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
              return;
            }
            this.sign.signature = signature;
            return this.signUsb(this.sign);
          }
        ).catch(e => {
          if (e && e.errorCode) {
            if (e.errorCode === 401) {
              // ngươif dùng huỷ, không chọn cts
                this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
              return;
            }
          }
          this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
        });
      });
    }
  }

  signUsb(certificate: any) {
    this.blockUI.start('');
    if(this.tempEnterprise){
      const payload = {
        type: this.signMethod.SIGN_USB_TOKEN,
        enterpriseUpdateInfoDTO: this.tempEnterprise,
        verifySignDTO:certificate,
        verify: false,
      }
      this.kycService.verifyAndUpdate(payload).subscribe((res) => {
        if (res.success) {
          this.onSignSuccess();
        } else {
          this.onSignFail(res.message);
        }
      });
    }else{
      this.kycService.signUsb(certificate).subscribe((res) => {
        if (res.success) {
          this.onSignSuccess();
        } else {
          this.onSignFail(res.message);
        }
      });
    }
  }

  private onSignSuccess() {
    this.blockUI.stop()
    if (this.hashKey && this.tenantId) {
      const dialogRe = this.dialog.open(ConfirmSuccessComponent, {
        width: '350px',
        data: {
          message: this.message.getMessage('kyc.success_des_anonymous'),
          hashKey: this.hashKey,
          tenantId: this.tenantId
        }
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          localStorage.removeItem('tempEnterprise');
          if(this.contractIdAndContractEnterpriseIdEncode) {
            this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
          }else {
            this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
          }
        }
        dialogRe.close();
      });
    } else {
      const dialogRe = this.dialog.open(ConfirmSuccessComponent, {
        width: '350px',
        data: {
          message: this.tempEnterprise
          ?this.message.getMessage('kyc.success_des_update')
          :this.message.getMessage('kyc.success_des'),
        }
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          localStorage.removeItem('tempEnterprise')
          this.success = true;
          this.backToSuccess();
        }
        dialogRe.close();
      });
    }

    // this.toastr.success(this.message.getMessage('messages.sign_success'));
    // this.success = true;
    // this.blockUI.stop();
    // this.backToSuccess();
  }

  private onSignFail(message) {
    this.blockUI.stop();
    if (this.hashKey && this.tenantId) {
      const dialogRe = this.dialog.open(ConfirmFailComponent, {
        width: '350px',
        data: {
          message: message ? message : (this.message.getMessage('kyc.fail_title')+', ' + this.message.getMessage('kyc.fail_title_2')),
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          hashLink: this.contractIdAndContractEnterpriseIdEncode
        }
      });
      dialogRe.afterClosed().subscribe(rs => {
        dialogRe.close();
      });
    } else {
      const dialogRe = this.dialog.open(ConfirmFailComponent, {
        width: '350px',
        data: {
          message: message ? message : (this.message.getMessage('kyc.fail_title')+', ' + this.message.getMessage('kyc.fail_title_2')),
        }
      });
      dialogRe.afterClosed().subscribe(rs => {
        dialogRe.close();
      });
    }
  }

  backToSuccess() {
    localStorage.setItem('SignDataValidateKyc', '');
    this.router.navigate([`/home-enterprise/analysis-report`]);
  }

  onClickSignButton() {
    this.isClickSignBuuton = true;
    if (this.isSelectPosition) {
      this.isClickSignBuuton = false;
      this.toastr.error(this.message.getMessage('messages.need_choose_position'));
      return;
    }

    this.sign = {
      listSignPosition: this.imageData,
      phoneNumber: this.digitalCertificateService.formatPhoneNumber(this.simCaPhoneNumber),
      ...this.selectedCert
    };

    if (!this.fileUpload) {
      this.onClickConfirmButtonNoImage();
    } else {
      this.sign = {
        ...this.sign,
        image: this.fileUpload,
      };
      this.onClickConfirmButtonImage();
    }

    setTimeout(() => {
      this.isClickSignBuuton = false;

    }, 5000)
  }

  onSelectImageSignMethod(type: number) {
    this.isDisableNextButton = false;
  }

  onClickBtnCancel() {
      if(this.tempEnterprise){
        const dialogRe = this.dialog.open(WarningComponent, {
          width: '350px',
          data: this.message.getMessage('messages.confirm_just_change_data')
        });
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {
            localStorage.removeItem('tempEnterprise');
            if (this.hashKey && this.tenantId) {
              if (this.contractIdAndContractEnterpriseIdEncode) {
                this.router.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`], {
                  queryParams: {
                    type: this.typeVerify
                  }
                });
              } else {
                this.router.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}`], {
                  queryParams: {
                    type: this.typeVerify
                  }
                });
              }
            } else {
              this.router.navigate([`/kyc-confirm-account`], {
                queryParams: {
                  type: this.typeVerify
                }
              });
            }

          }
          dialogRe.close();
        });
      }else{
        if (this.hashKey && this.tenantId) {
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.router.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`], {
              queryParams: {
                type: this.typeVerify
              }
            });
          } else {
            this.router.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}`], {
              queryParams: {
                type: this.typeVerify
              }
            });
          }
        } else {
          this.router.navigate([`/kyc-confirm-account`], {
            queryParams: {
              type: this.typeVerify
            }
          });
        }
      }
  }

  onClickBtnViewUpdate() {
    if(this.tempEnterprise){
      if(this.tenantId&&this.hashKey){
        if(this.contractIdAndContractEnterpriseIdEncode) {
          this.router.navigate([`/kyc-confirm-account-review/update-enterprise-review-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`], {
            queryParams: {
              type: this.typeVerify
            }
          });
        }else{
          this.router.navigate([`/kyc-confirm-account-review/update-enterprise-review-anonymous/${this.hashKey}/${this.tenantId}`], {
            queryParams: {
              type: this.typeVerify
            }
          });
        }
      }else{
        this.router.navigate(['/kyc-confirm-account-review/update-enterprise-review'], {
          queryParams: {
            type: this.typeVerify
          }
        });
      }
    }else{
      const id = localStorage.getItem('enterpriseId')
      if(this.tenantId&&this.hashKey){
        if(this.contractIdAndContractEnterpriseIdEncode) {
          this.router.navigate([`/kyc-confirm-account/update-enterprise-anonymous/${id}/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`], {
            queryParams: {
              type: this.typeVerify
            }
          });
        }else{
          this.router.navigate([`/kyc-confirm-account/update-enterprise-anonymous/${id}/${this.hashKey}/${this.tenantId}`], {
            queryParams: {
              type: this.typeVerify
            }
          });
        }

      }else{
        this.router.navigate([`/kyc-confirm-account/update-enterprise/${id}`], {
          queryParams: {
            type: this.typeVerify
          }
        });
      }
    }

  }

  nzSelectChange(event) {
    const {index} = event;
    this.indexSelect = index;
    if (this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.typeSelectCertificate !== this.signMethod.SIGN_NO_CERT) {
      if (index === 2) {
        this.isSelectDrawImage = true;
        this.isDisableNextButton = true;
        this.canvasService.setIsDisableBtnDeleteCanvas(true);
      }
      if (index === 1) {
        this.isDisableNextButton = true;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.isSelectDrawImage = false;
      }
      if (index === 0) {
        this.isDisableNextButton = false;
        this.isSelectDrawImage = false;
        this.fileUpload = this.selectedImage;
        this.imageUrlPreview = this.selectedImageUrl;
      } else {
        this.fileUpload = null;
        this.imageUrlPreview = '';
      }
    } else {
      if (index === 1) {
        this.isSelectDrawImage = true;
        this.isDisableNextButton = true;
        this.canvasService.setIsDisableBtnDeleteCanvas(true);
      }
      if (index === 0) {
        this.isSelectDrawImage = false;
        this.isDisableNextButton = true;
        this.fileUpload = null;
        this.avatarUrl = null;
      }
    }
  }

  onChangeSelectCertificateType(value: any) {
    this.typeCertificate = value;

    if (value === this.signMethod.SIGN_NO_CERT) {
      this.isDisableNextButton = false;
    } else {
      this.isDisableNextButton = true;
    }
  }

  getCertificateOfSimCA() {
    // this.simCaPhoneNumber = this.digitalCertificateService.formatPhoneNumber(this.simCaPhoneNumber);
    this.digitalCertificateService.getListCertificateSimCA(this.enterpriseId, this.simCaPhoneNumber).pipe(first()).subscribe(rs => {
      if (rs.data.length > 0) {
        this.listOfDataSimCa = rs.data.map((item, index) => {
          return {
            ...item,
            STT: index + 1
          };
        });
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_simCA'));
      }
    }, error => {
    });
  }

  onSelectedCert(event: any, cert) {
    if (event === true) {
      this.selectedCertSimCa = cert;
      this.selectedCert = cert;
      this.isDisableNextButton = false;
      this.listOfDataSimCa = this.listOfDataSimCa.map(item => {
        return {...item, checked: cert.STT === item.STT};
      });
    } else {
      this.isDisableNextButton = true;
      this.selectedCertSimCa = null;
    }
  }

  getInformCertificateFromFile(baseString: string, file) {
    this.digitalCertificateService.getInformCertificateFromFile({
      certRawdata: baseString
    }).subscribe(rs => {
      this.errorStatus = null;
      this.fileUpload = file;
      this.usbTokenCertificate = {
        ...this.usbTokenCertificate,
        activeDate: rs.data.activeDate,
        expireDate: rs.data.expireDate,
        certificateName: rs.data.certificateName,
        serialNumber: rs.data.serialNumber,
        distinguishedName: rs.data.distinguishedName,
        issuedBy: rs.data.issuedBy,
        certRawdata: baseString,
        taxCode: rs.data.taxCode
      };
    });
  }

  private reset() {
    this.inputUploadFile.nativeElement.value = '';
  }

  getFile(evt) {
    if (typeof (FileReader) !== 'undefined') {
      const file = evt.target.files[0];
      // Check format of file
      if (!this.checkFormatTypeFile(file)) {
        // Check size of file
        if (!this.checkSize(file.size)) {
          this.usbTokenCertificate.fileName = file.name;
          const reader = new FileReader();
          reader.onload = (e: any) => {
            // Base64 string of file
            const binaryData = e.target.result;
            this.usbTokenCertificate.certRawdata = window.btoa(binaryData);
            this.getInformCertificateFromFile(window.btoa(binaryData), file);
          };
          // Read in the image file as a data URL.
          reader.readAsBinaryString(file);
        }
      } else {
        if (!this.toastr.findDuplicate(this.message.getMessage('validation.file_format_error'), true, true)) {
          this.toastr.error(this.message.getMessage('validation.file_format_error'));
        }
      }
      this.reset();
    }
  }

  checkFormatTypeFile(file): boolean {
    if (file.type !== 'application/x-x509-ca-cert') {
      this.errorFormatTypeFile = true;
      return true;
    } else {
      return false;
    }
  }

  private checkSize(fileSize): boolean {
    if (fileSize > 5242880) {
      this.maxSizeInput = true;
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_file_5mb'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_file_5mb'));
      }
      return true;
    } else {
      this.maxSizeInput = false;
      return false;
    }
  }

  onGetCertificate() {
    this.blockUI.start('');
    initPluginCertificate(this);
    this.isDisableNextButton = false;
  }

  downloadSignPlugin(os ?: string) {
   let filename =  this.digitalCertificateService.getSignPluginName(os);
      this.digitalCertificateService.downloadSignPlugin(os).subscribe(rs => {
        this.downLoadFile(rs, 'application/octet-stream', filename);
      });
  }

  getLinkDownload(os ?: string){
    return  this.digitalCertificateService.linkDownloadPluginSign(os);
  }


  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  showErrMsgTransle(msg) {
    this.blockUI.stop();
    this.errorStatus = msg;
  }

  setSerialNumber(value) {
    this.usbTokenCertificate.serialNumber = value;
  }

  setIssuedTo(value) {
    this.usbTokenCertificate.issuedTo = value;
  }

  setDistinguishedName(value) {
    this.usbTokenCertificate.distinguishedName = value;
  }

  setTaxCode(value) {
    this.usbTokenCertificate.taxCode = value;
  }

  setIssuedBy(value) {
    this.usbTokenCertificate.issuedBy = value;
  }

  setCertRawdata(value) {
    this.usbTokenCertificate.certRawdata = value;
  }

  setActiveDate(value) {
    this.usbTokenCertificate.activeDate = new Date(value);
  }

  setExpireDate(value) {
    this.usbTokenCertificate.expireDate = new Date(value);
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  setCertData(value) {
    this.certData = value;
  }

  setActiveContinueButton() {
    this.isDisableNextButton = false;
  }

  genStampContent() {
    let contentNode: string;
    const padding = 10;
    const zoom = this.zoomLevel / 100;
    let widthRectangle = this.widthRectangle * zoom;
    let heightRectangle = this.heightRectangle * zoom;

    widthRectangle -= padding * zoom * 2;
    heightRectangle -= padding * zoom * 2;

    let height = widthRectangle;
    let width = heightRectangle;
    const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
    if (this.imagePreviewWidth > this.imagePreviewHeight) {
      width = widthRectangle;
      height = width / ratio;
      if (height > heightRectangle) {
        height = heightRectangle;
        width = height * ratio;
      }
    } else {
      height = heightRectangle;
      width = height * ratio;
    }

    const heightPx = `${height}px`;
    const widthPx = `${width}px`;

    if (this.fileUpload) {
      // tslint:disable-next-line:max-line-length
      contentNode = `
                 <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
                 <img src="${this.imageUrlPreview}" style="height: ${heightPx};width: ${widthPx}; margin: auto; display: flex; justify-content: flex-end; align-items: flex-start;"/>
                  `;
    } else {
      if (this.typeSelectCertificate === this.signMethod.SIGN_SIM_CA || this.typeCertificate === this.signMethod.SIGN_CLOUD_CA) {
        contentNode = `
        <div>
               <div id="notify_outside" style="position: absolute;top: -40px;left: 60px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.certificateName}
              <br/>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
         </div>
      `;
      } else {
        contentNode = `<div>
              <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.usbTokenCertificate.issuedTo}
              <br/>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
            </div>`;
      }
    }
    return contentNode;
  }

  changePhone(event: any) {
    if (event.target.value.trim().length === 10) {
      this.otpPhoneNumber = event.target.value.trim();
      this.isDisableNextButton = false;
    } else {
      this.isDisableNextButton = true;
    }
  }

  handleReaderLoaded(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.sign.base64SignImage = btoa(binaryString);
  }

  gotoSignPage() {
    // trang ký = 3
    this.pageCurrent = 3;
  }

  getCertificateCloudCa() {
    // this.simCaPhoneNumber = this.digitalCertificateService.formatPhoneNumber(this.simCaPhoneNumber);
    this.anonymousSignService.getCertsCloudCa(this.hashKey, this.cloudCaUsername, this.providerName).pipe(first()).subscribe(rs => {
      if (rs.data.length > 0) {
        this.cloudCaDataSource = rs.data.map((item, index) => {
          return {
            ...item,
            STT: index + 1
          };
        });
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_cloudCA'));
      }
    }, error => {
    });
  }

}

interface SimCaDataItem {
  STT: number;
  certificateName: string;
  serialNumber: string;
  taxCode: string;
  activeDate: any;
  expireDate: any;
  isUsed: boolean;
  checked: boolean;
}

interface CloudCaDataItem {
  STT: number;
  certificateName: string;
  cloudCaUserId: string;
  serialNumber: string;
  taxCode: string;
  activeDate: any;
  expireDate: any;
  isUsed: boolean;
  checked: boolean;
}

